import {selectIsLoading} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export function useGridIsLoading(): boolean {
  return useEagGridSelector(selectIsLoading);
}
